import {Record} from 'immutable';

export class Institution extends Record<{
    readonly institutionId: string;
    readonly image: string;
    readonly title: string;
    readonly pin: string;
}>({
    institutionId: '',
    image: '',
    title: '',
    pin: '',
}) {}

const fromAPI = data => {
    return new Institution(data);
};

export default {
    record: Institution,
    default: new Institution(),
    fromAPI,
};
